import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { FileItem, FileLikeObject, FileUploader, FileUploaderOptions, ParsedResponseHeaders } from 'ng2-file-upload';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'dmv-pub-input-file',
    templateUrl: './input-file.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InputFileComponent implements OnInit, OnDestroy {
    @Input() public label: string;
    @Input() public id: string;
    @Input() public message: string;
    @Input() public limitations: string;
    @Input() public set error(value) {
        this.error$.next(value);
    }
    @Input() private uploaderOptions: FileUploaderOptions;
    @Input() private validationErrors: { [name: string]: string };
    @Input() private formData: UntypedFormGroup;
    @Output() private success: EventEmitter<{ item: FileItem, response: string }>;

    @ViewChild('fileUpload', { static: true }) private fileUploadElement: ElementRef;

    public error$: Subject<string> = new BehaviorSubject(null);
    public describedBy$: Subject<string> = new BehaviorSubject(null);
    public uploader: FileUploader;
    public file$: Subject<string> = new Subject();
    private errorSubscription: Subscription;

    constructor() {
        this.success = new EventEmitter<{ item: FileItem, response: string }>();
    }

    public ngOnInit(): void {
        this.uploader = new FileUploader(this.uploaderOptions);
        this.uploader.onBeforeUploadItem = (fileItem: FileItem) => {
            fileItem.withCredentials = false;
        };
        this.uploader.onAfterAddingFile = (fileItem: FileItem) => {
            this.error$.next(null);
            this.file$.next(fileItem.file.name);
            fileItem.upload();
        };
        this.uploader.onWhenAddingFileFailed = (fileItem: FileLikeObject, filter: { name: string }, options: any) => {
            this.error$.next(this.validationErrors[filter.name] || 'UnknownError');
        };
        this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
            this.fileUploadElement.nativeElement.value = null;
            this.file$.next(null);
            this.success.emit({ item, response });
        };
        this.uploader.onErrorItem = (fileItem: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
            this.error$.next('UnknownError');
        };
        this.uploader.onBuildItemForm = (fileItem: FileItem, form: FormData) => {
            const values = this.formData.getRawValue();
            Object.keys(values).forEach(key => {
                form.append(key, values[key]);
            });
            form.append('BestandsNaam', fileItem.file.name);
            return { fileItem, form };
        };
        this.errorSubscription = this.error$.subscribe((error: string) => {
            if (!error) {
                this.describedBy$.next(this.message ? `${this.id}-message` : null);
            } else {
                this.describedBy$.next(`${this.id}-error`);
            }
        });
    }

    public ngOnDestroy(): void {
        if (this.errorSubscription) {
            this.errorSubscription.unsubscribe();
        }
    }
}
